module.exports = __webpack_public_path__ + "img/Asset 26.b74a266c.png";